import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ShipmentOrderSpec } from '@core/models/job-file/shipment-order-spec.model';
import { ConfirmationDialogComponent, ConfirmationDialogData, ConfirmationDialogResult } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { DeleteShipmentOrderJobFile } from '../../../../modules/wizard-v2/store/wizard.actions';

@Component({
  selector: 'hmt-order-row',
  templateUrl: './order-row.component.html',
  styleUrls: ['./order-row.component.scss'],
  standalone: false
})
export class OrderRowComponent {
  @Input() order!: ShipmentOrderSpec;
  @Input() selectable = false;
  @Input() deletable = true;
  @Input() isExpanded = false;
  @Output() toggleExpand = new EventEmitter<void>();
  @Output() deleteOrder = new EventEmitter<void>();
  @Output() selectOrder = new EventEmitter<{ selected: boolean; order: ShipmentOrderSpec }>();

  constructor(
    private dialog: MatDialog,
    private store: Store
  ) {}

  onToggleExpand(event: Event): void {
    event.stopPropagation();
    this.toggleExpand.emit();
  }

  onDeleteOrder(event: Event): void {
    event.stopPropagation();
    
    const dialogData: ConfirmationDialogData = {
      message: 'Are you sure you want to remove the order?',
      showCheckbox: true,
      checkboxText: 'Remove this order from Order Manager as well',
      imagePath: 'assets/icons/defaultIcon.png'
    };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '800px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((result: ConfirmationDialogResult) => {
      if (result && result.buttonPressed === 'yes') {
        const shouldDeleteFromOrderManager = result.checkboxChecked;
        const shipmentOrderId = this.order.id;
        this.store.dispatch(new DeleteShipmentOrderJobFile(shipmentOrderId, shouldDeleteFromOrderManager));
        this.deleteOrder.emit();
      }
    });
  }

  onSelectOrder(event: any): void {
    this.selectOrder.emit({ selected: event.checked, order: this.order });
  }

  calculateRemainingTime(deliveryEndDateTime: Date): string {
    try {
      const deliveryTime = new Date(deliveryEndDateTime).getTime();
      const currentTime = new Date().getTime();
      const seconds = Math.floor((deliveryTime - currentTime) / 1000);
      
      const minutes = Math.abs(seconds % 60);
      const days = Math.floor(seconds / (3600 * 24));
      const hours = Math.abs(Math.floor(((seconds / (3600 * 24)) % 1) * 24));
      
      return `${days}D ${hours}H ${minutes}M`;
    } catch (e) {
      return '';
    }
  }
}

